import { useIsInViewport } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent, watch, onMounted } from '@vue/composition-api';
import { useExperimentLogging } from './logging.js';

var script = defineComponent({
    props: {
        id: {
            type: String,
            required: true,
        },
        group: {
            type: String,
            required: true,
        },
    },
    setup: function (props) {
        var logExposure = useExperimentLogging().logExposure;
        var _a = useIsInViewport({
            // 20% of the element visible (since elements could theoretically be very large)
            threshold: 0.2,
            // For one second
            delay: 1000,
            // Only once
            once: true,
        }), isVisible = _a.isElementVisible, elementRef = _a.observedElementRef;
        function log(exposureType) {
            logExposure({
                experimentId: props.id,
                cohortGroup: props.group,
                exposureType: exposureType,
            });
        }
        watch(isVisible, function (nextIsVisible) {
            if (nextIsVisible) {
                log('visible');
            }
        });
        onMounted(function () {
            log('mounted');
        });
        function handleInteraction() {
            log('interaction');
        }
        return {
            elementRef: elementRef,
            handleInteraction: handleInteraction,
        };
    },
});

export default script;
